export default function() {
    return {
        templates: [],
        fields: [
            {
                key: 'name',
                label: 'Título'
            },
            {
                key: 'subject',
                label: 'Assunto'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
